export const domainTlds = [
  { tld: ".com.br", price: "40", promo: "Registro anual" },
  { tld: ".com", price: "60", promo: "Registro anual" },
  { tld: ".net", price: "65", promo: "Registro anual" },
  { tld: ".store", price: "55", promo: "Ideal para lojas" },
  { tld: ".online", price: "45", promo: "Registro anual" },
  { tld: ".app", price: "70", promo: "Ideal para sistemas" },
];

export const domainBenefits = [
  {
    icon: "ri-search-eye-line",
    title: "Busca de domínio",
    description: "Verifique a disponibilidade do nome ideal para a sua empresa.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Registro seguro",
    description: "Cuidamos do registro para o domínio ficar no nome certo e protegido.",
  },
  {
    icon: "ri-refresh-line",
    title: "Renovação acompanhada",
    description: "Lembretes e acompanhamento para o seu domínio nunca expirar.",
  },
  {
    icon: "ri-links-line",
    title: "Apontamento fácil",
    description: "Configuramos o domínio para o seu site, e-mail e demais serviços.",
  },
  {
    icon: "ri-mail-send-line",
    title: "E-mail profissional",
    description: "Comunicação empresarial com o domínio da sua empresa.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte dedicado",
    description: "Ajuda de verdade para registrar e configurar o seu domínio.",
  },
];

export const domainSteps = [
  {
    icon: "ri-search-line",
    title: "Busque o nome",
    description: "Digite o nome desejado e verifique a disponibilidade para a sua empresa.",
  },
  {
    icon: "ri-shopping-cart-2-line",
    title: "Escolha a extensão",
    description: "Selecione o final (.com.br, .com, .store e outros) que combina com o negócio.",
  },
  {
    icon: "ri-user-add-line",
    title: "Faça o registro",
    description: "Informe os dados do titular e confirmamos o registro do domínio.",
  },
  {
    icon: "ri-rocket-line",
    title: "Configure e use",
    description: "Apontamos o domínio para o seu site e e-mail profissional.",
  },
];

export const dominiosFaqs = [
  {
    question: "O domínio fica no meu nome?",
    answer:
      "Sim. O domínio é registrado no nome do titular informado, garantindo que a sua empresa tenha o controle do endereço.",
  },
  {
    question: "Qual extensão devo escolher?",
    answer:
      "Depende do seu objetivo. O .com.br reforça a presença local, enquanto .com e .store funcionam bem para alcance amplo e lojas virtuais. Fale com um especialista se ficar em dúvida.",
  },
  {
    question: "Preciso renovar o domínio?",
    answer:
      "Sim. O registro é anual e precisa ser renovado. A NXHOST acompanha as datas e ajuda você a manter o domínio ativo.",
  },
  {
    question: "Posso transferir um domínio que já tenho?",
    answer:
      "Sim. Se você já tem um domínio registrado em outro lugar, a nossa equipe orienta a transferência e a configuração na NXHOST.",
  },
  {
    question: "O registro já inclui hospedagem?",
    answer:
      "O registro é um serviço separado. Se quiser, reunimos domínio, hospedagem e site em um só lugar para facilitar a sua gestão.",
  },
];